import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import imgOtherMySpace from "../../assets/image-not-available.png";
import {
  ClickAwayListener,
  IconButton,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import { getFile } from "../../services/FileManager";
import { theme as themeConfig } from "../../themes/themes";
import {
  ButtonViewPreview,
  ContentButtons,
  ContentImg,
  ContentInfo,
  ContentTooltip,
  DateDescription,
  MySpaceDescription,
  MySpaceTitle,
  useStyles,
} from "./ListCardMySpaces.styled";
import InfoIcon from "@material-ui/icons/Info";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import moment from "moment";

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    pointerEvents: "auto",
    backgroundColor: themeConfig.neutral.white,
    margin: "9 0",
    color: themeConfig.neutral.gray[1700],
    border: `1px solid ${themeConfig.neutral.gray[800]}`,
    boxShadow: "4px 4px #92929236",
  },
}))(Tooltip);

const ListCardMySpaces = ({ myspace, goToDetail, isHomeView }) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = useState(imgOtherMySpace);
  const [openInfo, setOpenInfo] = useState(null);

  useEffect(() => {
    if (myspace.coverImageSrc) {
      getFile(myspace.coverImageSrc).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(imgOtherMySpace);
    }
  }, [myspace.coverImageSrc]);

  return (
    <Col
      md={3}
      className={classes.containerSpace}
      style={
        isHomeView ? {
          width: "25em",
          height: "13em",
          margin: "0 2.5em 0 0",
          display: "flex",
        } : {
          width: "fit-content",
          marginRight: "1.8em",
          marginBottom: "1.8em",
        }
      }
    >
      <ContentImg>
        <img src={previewImage} className={classes.imgOtherEvent} alt="" />
      </ContentImg>
      <ContentInfo>
        <MySpaceTitle onClick={() => goToDetail(myspace)}>
          {myspace.topic}
        </MySpaceTitle>
        <MySpaceDescription>
          <b onClick={() => goToDetail(myspace)}>Created by:</b>{" "}
          {myspace.createUser}
        </MySpaceDescription>
        <DateDescription onClick={() => goToDetail(myspace)}>
          <b>Active until:</b> {moment(myspace.finishDate).format("ddd,MMM DD")}{" "}
          |{" "}
          {new Date(myspace.finishDate).toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </DateDescription>
        <ContentButtons>
          <HtmlTooltip
            arrow
            placement="right"
            open={openInfo}
            title={
              <>
                <ClickAwayListener onClickAway={(e) => setOpenInfo(null)}>
                  <ContentTooltip>
                    <div>
                      <span style={{ fontWeight: "600" }}>Name:</span>{" "}
                      <span style={{ fontWeight: "400" }}>
                        {openInfo && openInfo.name}
                      </span>
                    </div>
                    <div>
                      <span style={{ fontWeight: "600" }}>Description:</span>{" "}
                      <span style={{ fontWeight: "400" }}>
                        {openInfo && openInfo.description}
                      </span>
                    </div>
                  </ContentTooltip>
                </ClickAwayListener>
              </>
            }
          >
            <IconButton onClick={() => setOpenInfo(myspace)}>
              <InfoIcon
                style={{
                  color: themeConfig.text.primary,
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              />
            </IconButton>
          </HtmlTooltip>
          <ButtonViewPreview
            className="btn"
            onClick={() => goToDetail(myspace)}
          >
            <ArrowForwardIcon style={{ fontSize: "1em" }} />
          </ButtonViewPreview>
        </ContentButtons>
      </ContentInfo>
    </Col>
  );
};
export default ListCardMySpaces;
